import { render } from "./DiscountsEdit.vue?vue&type=template&id=3e6920bc"
import script from "./DiscountsEdit.vue?vue&type=script&lang=js"
export * from "./DiscountsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__